import React from "react"
import styled from "styled-components"

const FooterGroup = styled.div`
  background: #f1f3f5;
  padding: 50px 0;
  width: 100%;
  display: grid;
  overflow: hidden;
  align-items: center;
`

const FooterGroupGroup = styled.div`
  max-width: 100%;
  margin: 0 auto;
  display: grid;
  grid-gap: 20px;
  align-items: center;
  justify-items: center;
`

const Text = styled.p`
  font-weight: 600;
  font-size: 24px;
  color: #486791;
  align-items: center;
  text-align: center;
  justify-items: center;
  justify-self: center;
`

const Button = styled.a`
  background: linear-gradient(90deg, #5d11f7 0%, #9b51e0 100%);
  box-shadow: 0px 10px 20px rgba(101, 41, 255, 0.15);
  border-radius: 30px;
  height: 30px;
  color: rgb(250, 250, 250);
  border: none;
  padding: 16px 60px;
  margin: 0;
  font-weight: 600;
  font-size: 24px;
  justify-self: center;
  transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
  cursor: pointer;
  &:hover {
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
    transform: translateY(-8px);
  }
`

const LinkGroup = styled.div`
  max-width: 100%;
  align-items: center;
  margin: 40px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px 50px;
  text-align: left;
  a {
    transition: 0.8s;
  }

  a:hover {
    color: black;
  }
`

const Copyright = styled.p`
  color: #486791;
  margin: 0 auto;
  padding: 0 20px;
  max-width: 100%;
  text-align: center;
  font-size: 20px;
`

const Footer = () => (
  <FooterGroup>
    <FooterGroupGroup>
      <Text>Your News. Your Voice. Your Views.</Text>
      <Button
        href="https://twitter.com/intent/tweet?url=https://viewsnews.co/&text=Your News. Your Voice. Your Views. Experience a brand new way of news interaction with @TheViewsNews"
        target="_external"
      >
        Tweet
      </Button>
      <LinkGroup>
        <a href="/">Home</a>
        <a href="https://medium.com/views-weekly">Newsroom</a>
        <a href="/jobs">Jobs</a>
        <a href="/leadership">Leadership</a>
        <a href="/beta">Beta</a>
        <a href="/community-guidelines">Guidelines</a>
        <a href="/privacy">Privacy Policy</a>
      </LinkGroup>
      <Copyright>
        Backgrounds courtesy of{" "}
        <a href="https://designcode.io" target="_blank">
          Design+Code
        </a>{" "}
        and{" "}
        <a href="https://unsplash.com" target="_blank">
          Unsplash
        </a>
        , iOS app in Swift, Site in React.
        <br />© 2019
      </Copyright>
    </FooterGroupGroup>
  </FooterGroup>
)

export default Footer
